<div class="px-3 py-2">
	<h4 align="center">LA DE CIFRIS INCONTRA TORINO</h4>
	<p>Il giorno <b>14 ottobre 2019</b> si è tenuta una nuova sessione a Torino della 
		costituenda associazione nazionale di crittografia <i>De Componendis Cifris</i>.
	<p>Questa sessione è la prima delle due sessioni territoriali del 2019.</p>
	<b>Luogo: Politecnico di Torino - Energy Center - Via Paolo Borsellino 38/16, Auditorium.</b>
	<p>
		L'incontro si propone di offrire una panoramica sulle attività di ricerca 
		in Piemonte, e in generale nel Nord Italia, riguardanti la Crittografia e 
		le sue applicazioni, coinvolgendo sia le numerose eccellenze accademiche, 
		sia il mondo delle aziende che operano nel settore. Questa è stata inoltre 
		l’occasione per presentare l’iniziativa nazionale De Componendis Cifris che 
		organizza l’evento insieme al Politecnico e all’Università di Torino.
		<br>
		L'iniziativa De Cifris di aggregazione delle competenze di Crittografia 
		vuole stimolare la collaborazione in ambito crittografico, coinvolgendo 
		sia le numerose eccellenze accademiche, che sono tuttora presenti in Italia, 
		sia il mondo delle aziende che operano nel settore.
	</p>
	<p><a href="../../../../assets/eventi/2019/Torino/Locandina-Torino.pdf">Locandina</a></p>
	<h5>PROGRAMMA</h5>
	<ul>
		<li><p><b>10:00 - 10:30  Registrazione partecipanti</b></p></li>
		<li>
			<p><b>10:30 - 11:40  Sessione I</b></p>
			<ul class="ulSon">
				<li>
					<p>10:30 Professore Guido Saracco<br>
						Politecnico di Torino <br>
						<i style="color: green;">Magnifico Rettore</i><br>
					</p>
				</li>
				<li>
					<p>10:40 Generale di Divisione Giuseppe Grassi<br>
						Guardia di Finanza <br>
						<i style="color: green;">Comandante Regionale Piemonte</i>
					</p>
				</li>
				<li>
					<p>10:50 Professore Marino Badiale<br>
						Università di Torino <br>
						<i style="color: green;">Direttore Dipartimento di Matematica</i>
					</p>
				</li>
				<li>
					<p>11:00 Assessore Matteo Marnati<br>
						Regione Piemonte <br>
						<i style="color: green;">Assessore Ambiente, Energia, Innovazione, Ricerca</i>
					</p>
				</li>
				<li>
					<p>11:10 Professore Massimiliano Sala<br>
						<i style="color: green;">Acting Director</i> <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_MassimilianoSala.pdf">De Componendis Cifris</a>
					</p>
				</li>
				<li>
					<p>11:20 Colonnello Pietro Bianchi<br>
						<i style="color: green;">Head Analysis Team</i> <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_PietroBianchi.pdf">Guardia di Finanza</a>
					</p>
				</li>
				<li>
					<p>11:30 Professore Marco Baldi<br>
						<i style="color: green;">Coordinatore unità Univ. Polit. delle Marche</i> <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_MarcoBaldi.pdf">Laboratorio Nazionale 
							CINI di Cyber Security</a>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>11.40 - 12.00   Coffee break</b></p></li>
		<li>
			<p><b>12:00 - 13:15  Sessione II</b></p>
			<ul class="ulSon">
				<li>
					<p>12:00 Ing. Andrea Molino<br>
						Telsy SPA <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_AndreaMolino.pdf">Aspetti 
							implementativi della Crittografia</a>
					</p>
				</li>
				<li>
					<p>12:15 Dott. Fabio Fiori<br>
						Fondazione Quadrans <br>
   				 	<a href="../../../../assets/eventi/2019/Torino/Slide_FabioFiori.pdf">Crittografia nella blockchain</a>
					</p>
				</li>
				<li>
					<p>12:30 Ing. Vincenzo Di Nicola<br>
						CONIO <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_VincenzoDiNicola.pdf">Custodia 
							di cryptovalute: Soluzioni industr. e ricerca appl.</a>
					</p>
				</li>
				<li>
					<p>12:45 Dott. Guido Bertoni<br>
						Security Pattern <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_GuidoBertoni.pdf">La 
							sicurezza dei sistemi IOT</a>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>13:00 - 14:30   Lunch Break</b></p></li>
		<li><p><b>14:30 - 16:00  Sessione III</b></p>
			<ul class="ulSon">
				<li>
					<p>14:30 Prof. Danilo Bazzanella<br>
						Politecnico di Torino <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_DaniloBazzanella.pdf">Crittografia 
							&#64;Torino: proposte didattiche e linee di ricerca</a>
					</p>
				</li>
				<li>
					<p>14:45 Dott. Simone Dutto<br>
						Politecnico, UNITN, Telsy <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_SimoneDutto.pdf">Post-quantum 
							cryptography based on error-correcting codes</a>
					</p></li>
				<li>
					<p>15:00 Prof. Nadir Murru<br>
						Università di Torino <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_NadirMurru.pdf">Applicazioni 
							di teoria dei numeri alla Crittografia</a>
					</p>
				</li>
				<li>
					<p>15:15 Prof. Alberto Leporati<br>
						Università Bicocca di Milano <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_AlbertoLeporati.pdf">Boolean 
							cryptographic functions and related combinatorial constructions</a>
					</p>
				</li>
				<li>
					<p>15:30 Prof. Andrea Visconti<br>
						Università di Milano <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_AndreaVisconti.pdf">Crittografia 
							&#64;UniMI: applicazioni e teoria</a>
					</p>
				</li>
				<li>
					<p>15:45 Prof. Giacomo Verticale<br>
						Politecnico di Milano <br>
						<a href="../../../../assets/eventi/2019/Torino/Slide_GiacomoVerticale.pdf">BlAsT: 
							Blockchain-Assisted Key Transparency for Device Authentication</a>
					</p>
				</li>
			</ul>
		</li>
		<li><p><b>16.50 - 17.00  Conclusioni</b></p></li>
	</ul>
	<hr>
	<p>Eventuali richieste possono essere inviate a: <a href="segreteria@decifris.it">segreteria&#64;decifris.it.</a></p>
	<p> Questo evento è stato coordinato a livello nazionale dall'Acting Director della De 
		Componendis Cifris e a livello locale dal Comitato De Cifris, che è rappresentato da:
	</p>
	<p>
		Prof. Danilo Bazzanella - <b>Politecnico di Torino;</b><br>
		Prof. Antonio Di Scala - <b>Politecnico di Torino;</b><br>
		Prof. Alessandro Languasco - <b>Università di Padova;</b><br>
		Prof. Alberto Leporati - <b>Università Milano Bicocca;</b><br>
		Prof. Nadir Murru - <b>Università di Torino;</b><br>
		Prof.ssa Lea Terracini - <b>Università di Torino;</b><br>
		Prof. Andrea Visconti - <b>Università di Milano;</b><br>
		Prof. Alessandro Zaccagnini - <b>Università di Parma</b>.<br>
	</p>
</div>
  